import React from "react";
import { newsData } from "../constants";
import { ShortDate } from "./smComponents/ShortDate";
import { ViewMoreButton } from "./smComponents/ViewMoreButton";
import { Patrocinadores } from "./smComponents/Patrocinadores";

export const Diapositivas = () => {
  return (
    <div className="max-width">
      <div className="diapositivas-ct-cards mw-ct">
        <h2 className="diapositivas">DIAPOSITIVAS</h2>
        <div className="wr-cg-3">
          {newsData.map(({ id, title, isPrimerEquipo }) => {
            return (
              <div className="news-card" key={id}>
                <div className="cgi-3-news">
                  <span className={`arti${id}`}></span>
                </div>
                <div className="card-body">
                  <ShortDate  isPrimerEquipo={isPrimerEquipo}/>
                  <h3 className="article-heading">{title}</h3>
                </div>
              </div>
            );
          })}
        </div>
        <ViewMoreButton />
        <Patrocinadores />
      </div>
    </div>
  );
};
